"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CRYPTO_CURRENCY_CODES = void 0;
exports.CRYPTO_CURRENCY_CODES = ["BTC", "ETH", "LTC"];
